<h2 mat-dialog-title class="dialog-title-warning">
  <mat-icon>warning</mat-icon>
  Vínculos encontrados!
</h2>

<mat-dialog-content>
  <div class="mb-4">
    <p>{{ data.mensagemExibicao }}</p>
  </div>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nova Categoria</mat-label>
      <mat-select formControlName="idCategoriaDestino">
        @for (cat of categoriasFiltradas; track cat.idCategoriaFinanceira) {
          <mat-option [value]="cat.idCategoriaFinanceira">
            {{ cat.descricao }}
          </mat-option>
        }
      </mat-select>
      @if (form.get('idCategoriaDestino')?.hasError('required')) {
        <mat-error> A escolha da nova categoria é obrigatória. </mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<div mat-dialog-actions class="dialog-actions-end">
  <button mat-flat-button class="btn-secondary" (click)="cancelar()" [disabled]="isLoading">Cancelar</button>
  <button
    mat-flat-button
    class="btn-primary"
    (click)="confirmarMigracao()"
    [disabled]="isLoading || form.invalid">
    @if (!isLoading) {
      <span>Confirmar e Migrar</span>
    }
    @if (isLoading) {
      <mat-spinner diameter="20"></mat-spinner>
    }
  </button>
</div>
